module.exports = "#error404{\n  top: 15em !important;\n}\n"